// extracted by mini-css-extract-plugin
export default {"control":"via-button_control__Bo1ch","methods":"via-button_methods__1evg2","method":"via-button_method__oZpYH","active":"via-button_active__1hs42"};